import { graphql } from 'react-apollo';

import { HierarchyItemHierarchyBreadcrumb } from '../../../../../../../graphql/queries/hierarchy-item';

const HierarchyItemHierarchyBreadcrumbOptions = {
  options: ({ match }) => ({
    variables: {
      id: match.params.albumMembershipGroupId,
    },
  }),
  skip: ({ match }) => !match.params.albumMembershipGroupId,
};
const getHierarchyItemHierarchyBreadcrumb = graphql(
  HierarchyItemHierarchyBreadcrumb,
  HierarchyItemHierarchyBreadcrumbOptions,
);

export default getHierarchyItemHierarchyBreadcrumb;
